export enum PaymentMethodType {
  CASH = "CASH",
  SWISH_COMPANY = "SWISH_COMPANY",
  SWISH_COMMERCE = "SWISH_COMMERCE",
  NETS_MOCK = "NETS_MOCK",
  NETS_TERMINAL = "NETS_TERMINAL",
  WESTPAY_CLOUD = "WESTPAY_CLOUD",
  VIVA = "VIVA",
  VIVA_CLOUD = "VIVA_CLOUD",
  VIVA_SMART_CHECKOUT = "VIVA_SMART_CHECKOUT",
  SOFTPAY = "SOFTPAY",
  CREDIT_NOTE = "CREDIT_NOTE",
  GIFT_CARD = "GIFT_CARD",
  OTHER = "OTHER",
  INVOICE = "INVOICE",
  ORDER = "ORDER",
  MARKETPAY_CLOUD = "MARKETPAY_CLOUD",
  MARKETPAY_LOCAL = "MARKETPAY_LOCAL",
  MARKETPAY_SDK = "MARKETPAY_SDK",
}
